// Cette version de scaffolding a été développé en se basant sur le 
// "reboot", et le "print", de Bootstrap 4 :
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_reboot.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_print.scss
//
// Bootstrap 4 n'utilise plus la dépendance "Normalize Css" 
// (https://github.com/necolas/normalize.css/), mais c'est le 
// cas pour le BAPE afin d'alléger une partie de la création du scaffolding. 
// Il est important de prendre connaissance du contenu de "Normalize Css" 
// avant de procéder à des changements.

require("normalize.css");
require("./scaffolding.scss");
require("./scaffolding-list.scss");


// WEBPACK FOOTER //
// ./Sig.Web/src/common/com-scaffolding/com-scaffolding.chunk.js